'use strict';

module.exports = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/axios/lib/defaults/transitional.js
// module id = 6GnE
// module chunks = 14